import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import useGetArticlesByTags from '../../api/useGetArticlesByTags';
import { useQuery } from 'react-query';
import { Container, Row, Col } from 'reactstrap';
import DisplayQueryError from '../shared/DisplayQueryError';
import LoadingSpinner from '../shared/LoadingSpinner';
import DocumentHead from '../shared/DocumentHead';
import Header from '../shared/Header';

// This page is used to display articles related to the topics discussed in the bot, which users can navigate to by clicking the "View more" button in the bot after asking a question that triggers an article
const ArticlesByTopicsPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const tags = searchParams.getAll('t');

    const getArticlesByTags = useGetArticlesByTags({ tags });

    const {
        data: articles,
        isLoading,
        error,
        refetch
    } = useQuery(['articlesByTags', ...tags], getArticlesByTags);

    if (error) {
        return <DisplayQueryError error={error} refetch={refetch} />;
    }

    if (isLoading || !articles) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <DocumentHead
                title=' - Articles by topic'
                description={
                    'Articles related to the topic(s): ' + tags.join(', ')
                }
            />
            <Header headerClassName='mini' />
            <section className='bg-white py-5'>
                <Container>
                    <h4 className='mb-0 mt-4'>
                        Articles related to{' '}
                        {tags.map((tag) => (
                            <Link
                                key={tag}
                                to={`/topic/${encodeURIComponent(tag)}`}
                                className='btn btn-outline-primary rounded-pill ms-2 px-2 py-1 btn-sm'
                            >
                                <small>{tag}</small>
                            </Link>
                        ))}
                    </h4>
                    <Row className='mt-2'>
                        {articles.map((article) => (
                            <Col key={article.slug} xs={12} lg={6}>
                                <Link
                                    to={`/article/${article.slug}`}
                                    className='question-link text-decoration-none'
                                >
                                    {article.title}
                                </Link>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ArticlesByTopicsPage;
